import React from 'react';

// containers
import Page from '../../layout/containers/Page/Page';
import CartContainer from '../../containers/CartContainer/CartContainer';

// Constants
import page from './page';

const CartPage = () => {
  return (
    <Page page={page}>
      <CartContainer />
    </Page>
  );
};

export default CartPage;
